const SPRIG_VARIANTS = {
  light: "/images/icon-soft.png",
  dark: "/images/icon-mist.png",
  sage: "/images/icon-sage.png",
  green: "/images/icon-green.png",
};

export const Sprig = ({ className = "w-8 h-8", variant = "light" }) => (
  <img src={SPRIG_VARIANTS[variant]} alt="" aria-hidden="true" className={className} />
);

export default function Logo({ dark = false, tagline = false }) {
  const src = tagline
    ? dark
      ? "/images/logo-tagline-light.png"
      : "/images/logo-tagline-dark.png"
    : dark
      ? "/images/logo-light.png"
      : "/images/logo-green.png";
  return (
    <img
      src={src}
      alt="Eucalypt Therapy — grow back stronger"
      className={tagline ? "h-16 w-auto" : "h-12 w-auto"}
      data-testid="site-logo"
    />
  );
}
